module.exports = {"realised":"Specify if the item has been performed.","helpType":"Specify the human help.","difficulty":"Specify the difficulty level.","satisfaction":"Specify the satisfaction level."}


//////////////////
// WEBPACK FOOTER
// ./resources/js/lang/en/errors.json
// module id = fT2w
// module chunks = 28